import { render } from "./StatsIcon.vue?vue&type=template&id=3ef694ae"
import script from "./StatsIcon.vue?vue&type=script&lang=js"
export * from "./StatsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__